module.exports = __webpack_public_path__ + "static/media/balajirangan.18872838.png";